import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'

import Text from '../Text'

import styles from './styles.scss'

const renderIcon = (customIcon, icon) => {
  if (customIcon){
    return customIcon
  }

  if (icon){
    return (
      <FontAwesomeIcon className={styles.icon} icon={icon} />
    )
  }

  return null
}

const defaultState = {
  expanded: false,
}

const SelectBox = (props) => {
  const {
    callbacks, items, selectedItemKey, size, style, uppercaseItems, ulStyle
  } = props
  const { selectItem } = callbacks || {}

  const [state, setState] = useSetState(defaultState)
  const { expanded } = state

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: expanded })

  useEffect(() => {
    if (isClickedOutside && expanded){
      setState({ expanded: false })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside, expanded])

  if (!items){
    return null
  }

  const selectedItem = items.find(item => item.key === selectedItemKey) || {}

  return (
    <div
      className={classnames(styles.root, styles[size] || styles.medium, uppercaseItems ? styles.uppercaseItems : null)}
      onClick={() => setState({ expanded: !expanded })}
      style={style}
    >
      <a className={styles.item}>
        {renderIcon(selectedItem.customIcon, selectedItem.icon)}
        <Text variant="ellipsis">{selectedItem.selectedTitle || selectedItem.title || 'Please Select...'}</Text>

        <FontAwesomeIcon className={styles.caret} icon={faCaretDown} />
      </a>

      {expanded && (
        <ul className={styles.list} ref={contentEl} style={ulStyle}>
          {items.map((item) => {
            const { customIcon, href, icon, key, onClick, title } = item

            return (
              <li key={key}>
                <a
                  className={classnames(styles.item, styles.listItem)}
                  href={href}
                  onClick={selectItem ? () => selectItem(item) : onClick}
                  title={title}
                >
                  {renderIcon(customIcon, icon)}
                  <Text variant="ellipsis">{title}</Text>
                </a>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

SelectBox.propTypes = {
  callbacks: PropTypes.shape({
    selectItem: PropTypes.func,
  }),
  items: PropTypes.arrayOf(PropTypes.shape({
    customIcon: PropTypes.object,
    href: PropTypes.string,
    icon: PropTypes.object,
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    title: PropTypes.string.isRequired,
  })),
  selectedItemKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(['medium']),
  style: PropTypes.object,
  ulStyle: PropTypes.object,
  uppercaseItems: PropTypes.bool,
}

export default SelectBox
